import request from 'superagent';
import get from 'lodash/get';
import prefix from 'superagent-prefix';
import { authLogout, getCompanyId } from '@core/shared';

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
function superagentAuth({ headers = {} } = {}) {
  return (baseReq) => {
    const ACCESS_TOKEN = sessionStorage.getItem("ACCESS_TOKEN");
    const defaultHeaders = __spreadValues$5({
      fp: localStorage.getItem("fp") || "1",
      ct: sessionStorage.getItem("ct") || "1",
      Authorization: "Bearer " + ACCESS_TOKEN,
      pt: sessionStorage.getItem("pt") || "1"
    }, headers || {});
    Reflect.ownKeys(defaultHeaders).forEach((k) => {
      let _k = k;
      const val = defaultHeaders[_k];
      val && baseReq.set(_k, val);
    });
  };
}
function resNewToken(res) {
  if (res && res.header && res.header["access_token"]) {
    const access_token = res.header["access_token"];
    const data = JSON.parse(decodeURIComponent(access_token));
    sessionStorage.setItem("ACCESS_TOKEN", data.access_token);
    sessionStorage.setItem("USER_INFO", JSON.stringify(data.user_info));
    sessionStorage.setItem("USER_NAME", data.user_info.name);
    sessionStorage.setItem("EXPIRES_IN", data.expires_in);
    sessionStorage.setItem("REFRESH_TOKEN", data.refresh_token);
    sessionStorage.setItem("sessionId", data.refresh_token);
    localStorage.setItem(
      "storeSessionData",
      JSON.stringify({
        userInfo: data.user_info,
        token: data.access_token
      })
    );
  }
}

const xmlParser = (res, fn) => {
  res.text = "";
  res.setEncoding("utf8");
  res.on("data", function(chunk) {
    res.text += chunk;
  });
};

function _onError(code, body = {}) {
  if (code === 401) {
    authLogout();
  }
}
const getBaseRequestInstance = (url, options = {
  method: "get"
}) => {
  let targetURL = url;
  const {
    method = "get",
    data,
    query,
    headers,
    requestType,
    onError,
    API_URL,
    accept
  } = options;
  let baseReq = request(method, targetURL);
  baseReq.use(
    superagentAuth({
      headers
    })
  );
  if (accept && accept == "xml") {
    baseReq.accept("xml").parse(xmlParser);
  }
  if (API_URL) {
    baseReq.use(prefix(API_URL));
  }
  if (requestType) {
    baseReq.type(requestType);
  }
  if (method == "get") {
    baseReq.query(data || {});
  } else {
    baseReq.query(query || {});
    baseReq.send(data || {});
  }
  return baseReq;
};
class API {
  invoke(url, options = {
    method: "get"
  }) {
    return new Promise((resolve, reject) => {
      const baseReq = getBaseRequestInstance(url, options);
      baseReq.timeout({
        response: 15 * 1e3,
        deadline: 15 * 1e3
      }).then((res) => {
        resNewToken(res);
        if (!res || !res.body) {
          return reject(res.body);
        }
        const code = get(res, options.codePath || "body.code", 500);
        const data = get(res, options.dataPath || "body.data", {});
        if (code === 200) {
          return resolve(data);
        } else {
          _onError(code, res.body);
          if (options.onError) {
            options.onError(code, res.body);
          }
          return reject(res.body);
        }
      }).catch((err) => {
        reject(err);
        if (options.onError) {
          options.onError(500, err);
        } else {
          _onError(500, err);
        }
      });
    });
  }
}
const api = new API();
const myRequest = api.invoke;

function fileDownloadApi(data) {
  return fetch(
    `/api/minio/v1/file/download/file?bucket=${data.bucket}&objectName=${data.objectName}&fileName=${data.fileName}`,
    {
      headers: {
        fp: localStorage.getItem("fp") || "1",
        ct: localStorage.getItem("ct") || "1",
        Authorization: "Bearer " + sessionStorage.getItem("ACCESS_TOKEN"),
        pt: sessionStorage.getItem("pt") || "1"
      }
    }
  ).then((res) => res.blob()).then((blob) => {
    return {
      blob: new Blob([blob]),
      type: blob.type
    };
  });
}

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
const uimsGatewayPath = "/api/uims";
function uimsGetMenuApi(systemId, options) {
  return myRequest(
    `${uimsGatewayPath}/v1/resource/getMenu/${systemId}`,
    options
  );
}
function uimsGetUserCompanyApi(options) {
  return myRequest(
    `${uimsGatewayPath}/v1/org/user/company`,
    options
  );
}
function uimsPutDefaultCompanyApi(data, options) {
  return myRequest(
    `${uimsGatewayPath}/v1/org/default/company`,
    __spreadValues$4({
      method: "put",
      data
    }, options)
  );
}
function uimsGetUserPermsApi(systemId, options) {
  return myRequest(
    `/api/uims/v1/resource-function/user/${systemId}/perms`,
    options
  );
}
function uimsPostGetDepartmentTreeApi(options) {
  return myRequest(
    `/api/uims/v1/org/department-tree`,
    __spreadValues$4({
      method: "post"
    }, options)
  );
}
function projectGetOrganizationTreeApi({
  companyId,
  projectId,
  departmentId
}, options) {
  return myRequest(
    `/api/project-system/v1/project/organization/table?projectId=${projectId || ""}&departmentId=${departmentId || ""}&companyId=${companyId || ""}`,
    __spreadValues$4({
      method: "get"
    }, options)
  );
}

function getCurrentUser() {
  try {
    const userInfoStr = sessionStorage.getItem("USER_INFO");
    if (!userInfoStr) {
      return {};
    }
    const userInfo = JSON.parse(userInfoStr);
    if (!userInfo) {
      return {};
    }
    return userInfo;
  } catch (error) {
    return {};
  }
}
function getMicroDevInitialState(systemId) {
  return new Promise(async (resolve, reject) => {
    const currentUser = getCurrentUser();
    try {
      const menuData = await uimsGetMenuApi(systemId);
      const userInfo = await uimsGetUserPermsApi(systemId);
      resolve({
        currentUser,
        menuData: {
          code: 200,
          data: menuData,
          message: "success."
        },
        systemId,
        userInfo: {
          code: 200,
          data: userInfo,
          message: "success."
        }
      });
    } catch (error) {
      resolve({
        currentUser,
        menuData: {
          code: 200,
          data: {
            resourceList: [],
            systemId: ""
          },
          message: "success."
        },
        systemId,
        userInfo: {
          code: 200,
          data: {},
          message: "success."
        }
      });
    }
  });
}

var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const headers = {
  "depend-uri": `/api/cms/v1/help/index/1`,
  "depend-method": "GET"
};
const suffix$2 = "/api/cms";
const cmsGetSystemArticleListApi = async (data = {}, options) => {
  let _data = __spreadValues$3({
    channel: 1,
    platformCode: 1
  }, data);
  return myRequest(`${suffix$2}/v1/help/systemArticleList`, __spreadValues$3({
    method: "post",
    data: _data,
    headers
  }, options));
};
const cmsGetHelpIndexListApi = async (data, options) => {
  const _a = data, { platformCode = 1, channel = 1 } = _a; __objRest(_a, ["platformCode", "channel"]);
  return new Promise(async (resolve, reject) => {
    try {
      const r = await myRequest(`${suffix$2}/v1/help/index/${channel}`, __spreadValues$3({
        method: "get",
        headers
      }, options));
      let resArr = r.helpCenterList || [];
      let systemHelpList = r.systemHelpList || [];
      if (systemHelpList && systemHelpList.length) {
        resArr = resArr.concat({
          name: "\u7CFB\u7EDF\u5E2E\u52A9",
          id: "xtbz",
          children: systemHelpList
        });
      }
      resolve(resArr);
    } catch (error) {
      reject([]);
    }
  });
};
const cmsPostHelpSearchApi = async (data, options) => {
  const _a = data, {
    platformCode = 1,
    content = "",
    channel = 1,
    systemIds = [0],
    pageNum = 1,
    pageSize = 10
  } = _a, other = __objRest(_a, [
    "platformCode",
    "content",
    "channel",
    "systemIds",
    "pageNum",
    "pageSize"
  ]);
  return myRequest(`${suffix$2}/v1/help/search`, __spreadValues$3({
    method: "post",
    data: __spreadValues$3({
      platformCode,
      content,
      channel,
      systemIds,
      pageNum,
      pageSize
    }, other),
    headers
  }, options));
};
function findIsLead(res, idMap) {
  return res.map((r) => {
    if (r && r.children && r.children.length) {
      r.children = findIsLead(r.children, idMap);
    }
    const selectable = !!r.path;
    if (selectable) {
      idMap[r.id] = r;
    }
    return __spreadProps$1(__spreadValues$3({}, r), {
      isLeaf: selectable,
      selectable
    });
  });
}
const cmsGetHelpGetCategoryApi = (platformCode = 1, channel = 1, options) => {
  return new Promise(async (resolve, reject) => {
    try {
      const r = await myRequest(`${suffix$2}/v1/help/get-category/${channel}`, __spreadValues$3({
        method: "get",
        data: {},
        headers: {
          "depend-method": "GET",
          "depend-uri": "/api/cms/v1/help/index/1"
        }
      }, options));
      const idMap = {};
      let systemHelpList = r.systemHelpList || [];
      if (systemHelpList.length) {
        systemHelpList = [
          {
            channel: null,
            id: "xtzn",
            name: "\u7CFB\u7EDF\u6307\u5357",
            parentId: "0",
            path: null,
            sortNum: null,
            sysId: null,
            children: systemHelpList.map((r2) => {
              return __spreadProps$1(__spreadValues$3({}, r2), {
                parentId: "xtzn"
              });
            })
          }
        ];
      }
      const res = findIsLead(
        systemHelpList.concat(r.helpCenterList || []),
        idMap
      );
      resolve({
        res,
        idMap
      });
    } catch (error) {
      reject([]);
    }
  });
};
const cmsGetHelpById = (id, options) => {
  return myRequest(`${suffix$2}/v1/help/${id}`, __spreadValues$3({
    method: "get",
    data: {},
    headers: {
      "depend-method": "GET",
      "depend-uri": "/api/cms/v1/help/index/1"
    }
  }, options));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const suffix$1 = "/api/scm";
const scmGetMaterialsTypeApi = async ({
  companyId = "",
  headers = {
    "depend-method": "POST",
    "depend-uri": "/api/activiti/v1/tasks/{taskId}/complete/formdata"
  }
} = {}, options) => {
  return myRequest(`${suffix$1}/v1/oss/materialsType/tree/${companyId}`, __spreadValues$2({
    method: "get",
    headers
  }, options));
};
const purchaseGetMaterialsTypeApi = async ({
  companyId = getCompanyId(),
  headers = {
    "depend-method": "POST",
    "depend-uri": "/api/activiti/v1/tasks/{taskId}/complete/formdata"
  }
} = {}, options) => {
  return myRequest(`/api/purchase-system/v1/materialsType/tree`, __spreadValues$2({
    method: "get",
    data: {
      companyId
    },
    headers
  }, options));
};
const purchaseGetMaterialsTypeDetailApi = async ({
  id,
  options,
  headers = {}
}) => {
  return myRequest(
    `/api/purchase-system/v1/materialsType/${id}`,
    __spreadValues$2({
      method: "get",
      headers
    }, options)
  );
};
const scmGetMaterialsTypeDetailApi = async ({
  id,
  options
}) => {
  return myRequest(
    `${suffix$1}/v1/oss/materialsType/getMaterialsType/${id}`,
    __spreadValues$2({
      method: "get"
    }, options)
  );
};
const purchasePutMaterialsType = async ({
  data,
  options
}) => {
  return myRequest(`/api/purchase-system/v1/materialsType`, __spreadValues$2({
    method: "put",
    data
  }, options));
};
const scmPutMaterialsType = async ({
  data,
  options
}) => {
  return myRequest(`${suffix$1}/v1/oss/materialsType`, __spreadValues$2({
    method: "put",
    data
  }, options));
};
const scmPostMaterialsTypeDelInfo = ({
  data,
  options
}) => {
  return myRequest(
    `${suffix$1}/v1/oss/materialsType/delInfo`,
    __spreadValues$2({
      method: "post",
      data
    }, options)
  );
};
const purchaseDeleteMaterialsType = ({
  data,
  id,
  headers,
  options
}) => {
  return myRequest(
    `/api/purchase-system/v1/materialsType/${id}`,
    __spreadValues$2({
      method: "delete",
      headers,
      data
    }, options)
  );
};
const scmPostMaterialsTypeTable = ({
  data,
  options
}) => {
  return myRequest(
    `${suffix$1}/api/v1/oss/materialsType/table`,
    __spreadValues$2({
      method: "post",
      data: __spreadValues$2({
        sourceType: 1,
        status: 0,
        parentId: 0,
        companyId: 0,
        pageNum: 1,
        pageSize: 10,
        code: "",
        name: ""
      }, data)
    }, options)
  );
};
const scmPostGenerateShareCode = ({
  system = "scm",
  data,
  options
}) => {
  return myRequest(
    `/api/${system}/v1/common/share/generate/code`,
    __spreadValues$2({
      method: "post",
      data
    }, options)
  );
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var REQUEST_API = /* @__PURE__ */ ((REQUEST_API2) => {
  REQUEST_API2["DICT_QUERY"] = "/api/uims/v1/dict/query";
  REQUEST_API2["DICT_QUERY_BY_TYPES"] = "/api/uims/v1/dict/query-by-types";
  return REQUEST_API2;
})(REQUEST_API || {});
const _isString = (data) => typeof data === "string";
const _isArray = (data) => Array.isArray(data);
const dictTable = (data = {}) => myRequest("/api/uims/v1/dict/table", {
  method: "post",
  data
});
const dictTypes = (data = {}) => myRequest("/api/uims/v1/dict/types", {
  method: "get",
  data
});
const DICT_KEY = "__DICT";
const getDictSesstion = () => {
  return JSON.parse(sessionStorage.getItem(DICT_KEY) || "{}");
};
const getDictSesstionValue = (key) => {
  const map = getDictSesstion();
  return map[key];
};
const setDictSesstion = (key, value) => {
  const map = getDictSesstion();
  sessionStorage.setItem(
    DICT_KEY,
    JSON.stringify(__spreadProps(__spreadValues$1({}, map), {
      [key]: value
    }))
  );
};
const getDataKey = (data) => {
  if (typeof data === "object") {
    const { type, types } = data;
    return (type || types || "").toString();
  }
  return data;
};
const dictQueryCode = (data, options) => {
  return new Promise((resolve, reject) => {
    if (!options) {
      const value = getDictSesstionValue(getDataKey(data));
      if (value) {
        resolve(value);
        return;
      }
    }
    const isString = _isString(data);
    const url = isString ? "/api/uims/v1/dict/query" /* DICT_QUERY */ : _isArray(data == null ? void 0 : data.types) ? "/api/uims/v1/dict/query-by-types" /* DICT_QUERY_BY_TYPES */ : "/api/uims/v1/dict/query" /* DICT_QUERY */;
    const isTypes = !isString && _isArray(data == null ? void 0 : data.types);
    myRequest(url, __spreadProps(__spreadValues$1({}, options), {
      data: __spreadValues$1({
        dataType: 2,
        status: 1,
        queryType: isString ? 1 : (data == null ? void 0 : data.parentId) ? 3 : 1
      }, isString ? { type: data } : data),
      method: "post"
    })).then((res) => {
      if (!isTypes && (!res || Object.keys(res).length <= 0)) {
        resolve([]);
      }
      setDictSesstion(getDataKey(data), res);
      resolve(res);
    }).catch(() => {
      resolve(isTypes ? {} : []);
    });
  });
};
const handleDictRequest = (url, options, ...params) => {
  return new Promise((resolve, reject) => {
    var _a;
    const [query, type] = url.split("/").slice(-2);
    const isTypes = query == "codes";
    const _params = __spreadProps(__spreadValues$1({}, options), {
      data: __spreadValues$1(__spreadValues$1({
        dataType: 2,
        queryType: ((_a = options.data) == null ? void 0 : _a.parentId) ? 3 : 1,
        status: 1
      }, isTypes ? { types: type.split(",") } : { type }), options.data),
      method: "post"
    });
    myRequest(isTypes ? "/api/uims/v1/dict/query-by-types" /* DICT_QUERY_BY_TYPES */ : "/api/uims/v1/dict/query" /* DICT_QUERY */, _params).then((res) => {
      if (!isTypes && (!res || Object.keys(res).length <= 0)) {
        resolve([]);
      }
      resolve(res);
    }).catch(() => {
      resolve(isTypes ? {} : []);
    });
  });
};
const handleDictObjRequest = (url, options, ...params) => {
  return new Promise((resolve, reject) => {
    var _a;
    const [query, type] = url.split("/").slice(-2);
    const isTypes = query == "codes";
    const _params = __spreadProps(__spreadValues$1({}, options), {
      data: __spreadValues$1(__spreadValues$1({
        dataType: 2,
        queryType: ((_a = options.data) == null ? void 0 : _a.parentId) ? 3 : 1,
        status: 1
      }, isTypes ? { types: type.split(",") } : { type }), options.data),
      method: "post"
    });
    myRequest(isTypes ? "/api/uims/v1/dict/query-by-types" /* DICT_QUERY_BY_TYPES */ : "/api/uims/v1/dict/query" /* DICT_QUERY */, _params).then((res) => {
      if (!isTypes && (!res || Object.keys(res).length <= 0)) {
        resolve({
          code: 200,
          data: []
        });
      }
      resolve({
        code: 200,
        data: res
      });
    }).catch(() => {
      resolve({
        code: 200,
        data: isTypes ? {} : []
      });
    });
  });
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const suffix = "/api/cms";
const cmsPostContentNoticePage = ({
  noticeType = "1",
  pageNum = "1",
  pageSize = "3",
  options
}) => {
  return myRequest(
    `${suffix}/v1/cms/content/notice/page`,
    __spreadValues({
      method: "post",
      headers: {
        "depend-uri": `/api/uims/v1/system/list/{useScope}`,
        "depend-method": "GET"
      },
      data: {
        noticeType,
        pageNum,
        pageSize
      }
    }, options)
  );
};

export { API, REQUEST_API, cmsGetHelpById, cmsGetHelpGetCategoryApi, cmsGetHelpIndexListApi, cmsGetSystemArticleListApi, cmsPostContentNoticePage, cmsPostHelpSearchApi, dictQueryCode, dictTable, dictTypes, fileDownloadApi, getBaseRequestInstance, getCurrentUser, getMicroDevInitialState, handleDictObjRequest, handleDictRequest, myRequest, projectGetOrganizationTreeApi, purchaseDeleteMaterialsType, purchaseGetMaterialsTypeApi, purchaseGetMaterialsTypeDetailApi, purchasePutMaterialsType, resNewToken, scmGetMaterialsTypeApi, scmGetMaterialsTypeDetailApi, scmPostGenerateShareCode, scmPostMaterialsTypeDelInfo, scmPostMaterialsTypeTable, scmPutMaterialsType, superagentAuth, uimsGatewayPath, uimsGetMenuApi, uimsGetUserCompanyApi, uimsGetUserPermsApi, uimsPostGetDepartmentTreeApi, uimsPutDefaultCompanyApi };
